export default __webpack_public_path__ + "static/media/placeholder.4546234b.png";